<script setup lang="ts">
const props = defineProps<{
  on?: boolean
  round?: boolean
  disabled?: boolean | None
}>()
</script>

<template>
  <span :class="[$style.i, props, round && '_br99']">
    <svg
      :class="$style.check"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke-linecap="round"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    >
      <path d="M6 13 10 17 18 8" />
    </svg>
  </span>
</template>

<style module>
:global(.d) :global(.IconCheckbox):not(:global(.on)):not(:disabled):hover .i::before {
  opacity: 0.3;
  transform: scale(1.4);
}
:global(.d) :global(.IconCheckbox):not(:global(.on)):not(:disabled):hover .check {
  transform: scale(0.7);
  opacity: 0.99;
}
:global(.IconCheckbox):global(.on) .check,
.i:global(.on) .check {
  transform: scale(1);
  opacity: 0.99;
}
:global(.IconCheckbox):global(.on) .i,
.i:global(.on) {
  transition:
    transform 0.2s ease,
    opacity 0.05s ease;
}
:global(.IconCheckbox):global(.on) .i::before,
.i:global(.on)::before {
  opacity: 0.99;
  transform: scale(1.4);
}

.check {
  composes: global(_svg14);
  composes: global(_c0);
  --svg-color: var(--bg);
  composes: global(_relative);
  transition:
    transform 0.2s ease,
    opacity 0.1s ease 0.1s;
  transform: scale(0.01);
  opacity: 0.01;
}

.i {
  composes: global(_relative);
  composes: global(_hidden);
  composes: global(_noflex);

  composes: global(_ctr);
  composes: global(_bg0);

  composes: global(_h20);
  composes: global(_w20);
  composes: global(_a1);

  border: 1px solid var(--black-6);
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow: 0 0 0 1px var(--black-4);
  margin: 1px;

  z-index: 2;
}
.i::before {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  content: '';
  background: var(--black);
  opacity: 0;
  border-radius: 50%;
  transform: scale(0.01);
  transition:
    transform 0.2s ease,
    opacity 0.05s ease 0.05s;
}

:global(.d) :global(.IconCheckbox):not(:disabled):hover .i:global(.round) {
  box-shadow:
    0 0 0 1px var(--black-4),
    0 0 0 6px hsla(240, 10%, 94%, 0.5);
}

.i:global(.disabled) {
  background: var(--black-5);
}
</style>
